<template>
    <div class="whole_dialog">
        <el-dialog
            :title="$t('LnkWxImageText.title')"
            @closed="closeDialog"
            :visible.sync="imgtextDialog"
            width="720px"
            top="20px"
            center
            append-to-body
            :close-on-click-modal="false"
            :close-on-press-escape="false">
            <div class="whole_form whole_imgtext lnk-wx-image-text">
                <div class="header-left">
                    <div class="left-ipt">
                        <el-input
                            :placeholder="$t('LnkWxImageText.searchPlaceholder')"
                            clearable
                            v-model="imgtext.imgtextCnt"
                            @keyup.enter.native="searchimgtext">
                        </el-input>
                    </div>
                    <div class="left-ipt left-search">
                        <el-button type="primary" class="search" @click="searchimgtext" style="width: 68px;position: relative;left: -1px;">查询</el-button>
                    </div>
                </div>
                <!--imgtext-table-->
                <div class="imgtext_dialog clearfix">
                    <div class="image_item" v-for="(item,index) in imgtext.imagestextdalog" :key="index" :class="imgtexthover==index?'imgtext_hover':''" @click="selectimgtext(item,index)">
                        <p class="wx_title wx_left" style="width:190px;">{{item.title}}</p>
                        <div class="wx_img">
                            <img class="img_item" :src="item.url==''?'images/default.png':item.url+srcEnd" alt=""/>
                            <div class="wx_desc wx_sec">{{item.digest==''?$t('LnkWxImageText.noDescribe'):item.digest}}</div>
                        </div>
                        <div class="footer_opera">
                            <div class="footer_time wx_left">{{item.created}}</div>
                        </div>
                    </div>
                </div>
                <!--分页-->
                <div class="block">
                    <lnk-pagination-v :page="imgtext.pagedialog.page"
                                      :rows="imgtext.pagedialog.pageSize"
                                      :total="imgtext.pagedialog.totalcount"
                                      :page-sizes="[6]"
                                      @size-change="imgtextSizedalogChange"
                                      @current-change="imgtextCurrentdalogChange">
                    </lnk-pagination-v>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelimgtext" style="color: #1F74FF ;border-color: #1F74FF ;background-color: #fff;">{{$t('global.cancel')}}</el-button>
                <el-button type="primary" @click="comfirmimgtext" :disabled="confirmDisabled">{{$t('global.confirm')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

/**
     @name:微信素材选择组件  ps：只能输入数字 小数点
     @createdby:常九福
     @example template:
     <lnk-wx-image-text
      :wxId = ""
     :imgvisible.sync = "show"
     @change = "getSelectImg"
     ></lnk-wx-image-text>
     methods:{
       getSelectImg(val){
            val 就是所选择的图文对象
       }
     }

     @props:
     wxId:String,  //微信公众号id

     **/


export default {
    name: 'lnk-wx-image-text',
    data: function(){
        return {
            imgtextDialog: false, // 图文弹出框
            // 图文弹出框
            imgtext: {
                pagedialog: {
                    page: 1,
                    pageSize: 6,
                    totalcount: 0
                },
                imagestextdalog: [], // 图文弹出框list数据
                imgtextCnt: '', // 图文弹出框搜索框绑定数据
                imgtextmuiltip: {}, // 图文弹出框选中后缓存
                imgtextData: [], // 图文选中后展示数据
                modelimgtextStatus: false// 被关注自动回复图文模板显示与隐藏
            },
            imgtexthover: -1, // 图文弹出框浮动显示边框与否

            srcEnd: '?' + Math.random(),
            confirmDisabled: false // 确认按钮禁用
        };
    },
    props: {
        imgvisible: {// 是否显示
            type: Boolean,
            default: false
        },
        wxId: { // 微信公众号Id
            type: String,
            default: ''
        }
    },
    watch: {
        imgvisible: {
            immediate: true,
            handler: function (val){
                this.imgtextDialog = Boolean(val);
                if(this.imgtextDialog){
                    this.confirmDisabled = false;
                    this.getimagetextdalogData();// 图文信息弹出框加载
                }
            }
        }
    },
    methods: {

        /**
         * 图文弹出框-自动回复
         */
        getimagetextdalogData: function(){ // 获取图文列表list数据
            var filteraw=[
                {id: 'wxId', property: 'wxId', operator: '=', value: this.wxId},
                {id: 'title', property: 'title', operator: 'like', value: this.imgtext.imgtextCnt}
            ];
            axios1.post(appCtx.ctxPath+`/action/${LinkVue.prefixUrl}/articles/queryByExamplePage`, {
                page: this.imgtext.pagedialog.page,
                rows: this.imgtext.pagedialog.pageSize,
                oauth: window.CURRENT_ORIGIN_TOP.oauth,
                pageFlag: true,
                totalFlag: true,
                filtersRaw: JSON.stringify(filteraw)
            }).
                then((response) => {
                    var imagestextdata=response.data.rows;
                    this.imgtext.imagestextdalog=imagestextdata;
                    this.imgtext.pagedialog.totalcount=response.data.total;
                }).
                catch(function (error) {

                });
        },
        imgtextCurrentdalogChange: function(val){ // 改变当前页
            this.imgtext.pagedialog.page=val;
            this.getimagetextdalogData();
        },
        imgtextSizedalogChange: function(val){ // 改变每页显示的数量
            this.imgtext.pagedialog.pageSize=val;
            this.imgtext.pagedialog.page=1;
            this.getimagetextdalogData();
        },
        searchimgtext: function(){
            this.imgtext.pagedialog.page=1;
            this.getimagetextdalogData();
        },
        /* 浮动图文显示或者隐藏border*/
        selectimgtext: function(item, index){ // 点击确定选中某一个图文
            this.imgtext.imgtextmuiltip = item;// 选中缓存到图文缓存区
            this.imgtexthover=index;
        },
        comfirmimgtext: function(){ // 选中图文-确定显示在页面内
            if(Object.keys(this.imgtext.imgtextmuiltip).length == 0){
                this.$message({
                    message: '请选择图文',
                    type: 'warning'
                });
                return;
            }
            if(this.confirmDisabled){
                return;
            }
            this.confirmDisabled = true;
            this.$emit('change', this.imgtext.imgtextmuiltip); // 把选择的数据传递到组件外边
            this.imgtext.imgtextmuiltip = {};
            this.imgtextDialog = false;
            this.$emit('update:imgvisible', false);
        },
        cancelimgtext: function(){ // 取消选中的图文-不展示出来
            this.imgtexthover = -1;
            this.imgtext.imgtextmuiltip = {};
            this.$emit('update:imgvisible', false);
        },
        /**
         *@createdBy 常九福
         *@date 2018/12/26
         *@methods:closeDialog
         *@description:关闭弹出框，刷新组件数据
         **/
        closeDialog(){
            this.imgtexthover = -1;
            this.imgtext.imgtextmuiltip = {};
            this.$emit('update:imgvisible', false);
        }
    }
};
</script>

<style scoped>
    /*图片素材组件上传样式*/
    *{
        margin:0;
    }
    .clear{
        clear:both;
        font-size:1px;
        height:0;
        visibility:hidden;
        line-height:0;
    }
    .clearfix:after{
        content:"";
        display:block;
        clear:both;
    }
    .clearfix{
        zoom:1;
    }
    img{
        border:0;
        vertical-align:middle;
    }
    /*图文弹出框组件样式*/
    .lnk-wx-image-text .header-left{
        width:100%;
        margin-bottom:15px;
        height:28px;
    }
    .lnk-wx-image-text .left-ipt{
        width:240px;
        height:28px;
        float:left;
    }
    .lnk-wx-image-text .left-ipt /deep/ .el-input__inner{
        height:28px;
    }
    .lnk-wx-image-text .left-search{
        width:68px;
        vertical-align:0;
    }
    .lnk-wx-image-text .left-search /deep/ .el-button{
        min-width: 68px;
        background-color: #1F74FF ;
        height:28px;
        padding: 0;
    }
    .lnk-wx-image-text .imgtext_dialog .image_item{
        cursor:pointer;
        width:200px!important;
        height:168px;
        float: left;
        padding:0px;
        margin-right:16px;
        margin-bottom:16px;
        border: 1px solid #d9d9d9;
    }
    .lnk-wx-image-text .imgtext_dialog>div:nth-child(3n){
        margin-right:0;
    }
    .lnk-wx-image-text .imgtext_hover{
        border:1px solid #1F74FF !important;
    }
    .lnk-wx-image-text .imgtext_dialog .wx_img{
        height:112px!important;
        position:relative;
    }
    .lnk-wx-image-text .imgtext_dialog .img_item{
        height:112px!important;
    }
    .lnk-wx-image-text .imgtext_dialog .img_item,.imgtext_dialog .wx_desc{
        width:200px!important;
    }
    .lnk-wx-image-text .wx_title{
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
        line-height:12px;
        margin-bottom:8px;
        margin-top:8px;
        color: #384161;
    }
    .lnk-wx-image-text .imgtext_dialog .wx-img,.img_item{
        height:140px;
    }
    .lnk-wx-image-text .imgtext_dialog .wx_img{
        position:relative;
    }
    .lnk-wx-image-text .imgtext_dialog .wx_desc{
        position:absolute;
        left:0;
        bottom:0;
        background:rgba(56, 65, 97, 0.52);
        width: 184px!important;
        font-size:12px!important;
        height: 29px!important;
        line-height: 16px!important;
        padding: 4px 8px!important;
        word-break:break-all;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box !important;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
        color:#fff;
    }
    .lnk-wx-image-text .imgtext_dialog .delete_text{
        margin-left:16px;
        margin-top:167px;
    }
    .lnk-wx-image-text .imgtext_dialog .delete_menu{
        display:inline-block;
        margin-left:24px;
        float:left;
    }
    .lnk-wx-image-text .footer_opera{
        margin-top:7px;
    }
    .lnk-wx-image-text .block .el-input{
        width:auto;
    }
    .lnk-wx-image-text .imgtext_dialog .item_three{
        margin-right:0px;
    }
    .lnk-wx-image-text .whole_form .block{
        margin-top:0px;
    }
    .lnk-wx-image-text .imgform_left{
        height: 422px;
        overflow: hidden;
        overflow-y: auto;
    }
</style>
